import g from "./common.texts";
import rc from "../components/refundCalculation/RefundCalculation.texts";
import rt2 from "../pages/[brand]/return/Return.texts";
import co from "../pages/[brand]/return/methodSelector/complaint/ComplaintStepper.texts";
import st from "../pages/[brand]/status/[order].texts";
import ss from "../pages/[brand]/shipment-method/shipment-method.texts";
import c from "../pages/[brand]/confirmation/confirmation.texts.js";
import ple from "../pages/[brand]/status/eventComponents/PrintLabelEventComponent.texts.js";
import pdb from "../components/print/PrintDocumentsButton.texts";
import sc from "../cores/shipment.core.texts";
import er from "../components/alerts/Error.texts";
import br from "../pages/[brand]/index.texts";
import dra from "../app/apps/digitalReturns/DigitalReturnApp.text";
import est from "../pages/[brand]/return/methodSelector/exchange/ExchangeStepper.texts";
import suc from "../pages/[brand]/success/index.texts";
import pay from "../pages/[brand]/exchange/[orderToken]/payment.texts";
import pac from "../pages/[brand]/packing-instructions/[order]/index.texts";
import pit from "../components/productItem/ProductItem.texts";

export const textFiles = [g, rc, rt2, co, st, ss, ple, c, pdb, sc, er, br, dra, est, suc, pay, pac, pit];

export const ALL_TEXTS = textFiles.reduce((res, textFile) => ({ ...res, ...textFile }), {});
